<template>
  <!-- 忘记密码页 -->
  <main-bg>
    <div>
      <h3 class="title">忘记密码</h3>
      <div style="height:34px;"></div>
      <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent>
        <el-form-item prop="telephone" :error="telephoneErr">
          <el-input
            placeholder="请输入手机号码"
            v-model.trim="form.telephone"
            type="number"
            clearable
            auto-complete="new-password"
          >
            <svg-icon icon="telephone" slot="prefix" size="24px" />
          </el-input>
        </el-form-item>

        <el-form-item prop="telephone_code" :error="smsErr">
          <div class="code-input">
            <el-input
              placeholder="请输入验证码"
              v-model="form.telephone_code"
              auto-complete="new-password"
            />
            <el-button class="code" @click="onGetSmsCode" :disabled="smsDisabled">{{ smsBtnText }}</el-button>
          </div>
        </el-form-item>

        <el-form-item prop="password" :error="passwordErr">
          <el-input
            placeholder="请输入新密码"
            type="password"
            v-model="form.password"
            auto-complete="new-password"
          >
            <svg-icon icon="password" slot="prefix" size="24px" />
          </el-input>
        </el-form-item>

        <zt-button
          type="primary"
          :loading="loading"
          :disabled="disabled"
          @click.enter.exact="onSubmit"
          native-type="submit"
        >完成</zt-button>
        <router-link class="register-link" to="/?tabs=1">使用手机验证码登录</router-link>
      </el-form>

      <!-- 图形验证码弹框 -->
      <image-code-dialog
        :visible.sync="imgDialogVisible"
        :telephone="form.telephone"
        @success="onSuccess"
        api-type="forget"
      />
    </div>
  </main-bg>
</template>

<script>
import ImageCodeDialog from "@/views/login/components/ImageCodeDialog";
import { countdownSeconds, sleep } from "@/utils/timer";
import { password_reset } from "@/api/login";
import mainBg from "@/views/layout/mainBg";

export default {
  name: "Forget",
  components: {
    ImageCodeDialog,
    mainBg
  },

  data: () => ({
    form: {
      telephone: "",
      telephone_code: "",
      password: ""
    },
    rules: {
      telephone: [{ required: true, message: "请输入手机号码" }],
      telephone_code: [{ required: true, message: "请输入验证码" }],
      password: [{ required: true, message: "请输入密码" }]
    },
    telephoneErr: "",
    smsErr: "",
    passwordErr: "",

    loading: false,
    disabled: false,
    imgDialogVisible: false,

    smsCountdownTimer: null,
    smsBtnText: "获取验证码",
    smsDisabled: false
  }),
  watch: {
    "form.telephone"(val) {
      if (val.indexOf(" ") !== -1) {
        this.form.telephone = this.form.telephone.replace(/\s+/g, "");
      }
    }
  },
  methods: {
    // 提交表单
    onSubmit() {
      const { form } = this.$refs;

      form.validate(valid => {
        if (!valid) return false;

        this.loading = true;
        password_reset({ ...this.form })
          .then(({ data }) => {
            const { error_code, error_message } = data;

            // 手机错误或用户不存在
            if (error_code == 1 || error_code == 3) {
              this.setErr("telephoneErr", error_message);
            }
            // 没输入密码
            else if (error_code == 2) {
              this.setErr("passwordErr", error_message);
            }
            // 短信验证码错误
            else if (error_code == 7) {
              this.setErr("smsErr", error_message);
            } else if (error_code != 0) {
              this.$message({
                type: "error",
                message: error_message
              });
            } else {
              this.$message({
                type: "success",
                message: "密码修改成功",
                duration: 900
              });
              sleep(() => {
                this.$router.replace({ path: "/" });
              }, 1200);
            }

            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },

    onGetSmsCode() {
      const { form } = this.$refs;
      // 有手机号码就展示dialog
      form.validateField(["telephone"], err => {
        if (!err) {
          this.imgDialogVisible = true;
        }
      });
    },

    // 发送验证码成功
    onSuccess() {
      // 倒计时60s
      clearInterval(this.smsCountdownTimer);
      this.smsCountdownTimer = countdownSeconds({
        current: count => {
          this.smsBtnText = count;
          this.smsDisabled = true;
        },
        lastone: () => {
          this.smsDisabled = false;
          this.smsBtnText = "获取验证码";
        },
        count: 60
      });
    },

    // 设置err，修复重复错误无法重复提示
    setErr(name, error_message) {
      this[name] = " ";
      this.$nextTick(() => {
        this[name] = error_message;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/login.scss";
</style>